/** One flat panel joins existing report tabs, filters, and table content. */
export const tablePanelStyles = ({ palette, borders }) => ({
  minWidth: 0,
  border: "1px solid #d9d9d1",
  borderRadius: borders.borderRadius.xl,
  backgroundColor: palette.white.main,
  "& > [role=tabpanel] > .MuiBox-root": { pt: 0 },
});

/** Shared compact filter styling, scoped to table forms. */
export const filterPanelStyles = ({ palette }) => ({
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
    lg: "repeat(4, minmax(0, 1fr))",
  },
  gap: 1.625,
  px: { xs: 2, sm: 2.875 },
  py: 2.25,
  backgroundColor: palette.surface.main,
  borderBottom: "1px solid " + palette.grey[300],
  "& > .MuiBox-root": { mb: 0, minWidth: 0, height: "auto" },
  "& label": { fontSize: 13, fontWeight: 500 },
  "& .MuiInputBase-root, & .table-filter__control": { height: 40, minHeight: 40 },
  "& .MuiFormControlLabel-root": { m: 0 },
  "& .MuiFormControlLabel-label": { fontSize: 14, fontWeight: 400 },
  "& .MuiButton-root": { borderRadius: "10px", minHeight: 40 },
});
